import axiosInstance from 'helpers/axiosInstance';
import { useMutation } from 'react-query';

export const useCreateLeadFromMember = () => {
  return useMutation(({ memberId, leadType = 'NP' }: { memberId: string; leadType?: string }) => {
    return axiosInstance
      .post('/patients/leads/create_from_member', { member_id: memberId, lead_type: leadType })
      .then((r) => r.data);
  });
};
